/**
 * T-046: recent restore activity (last 7d, capped at 20).
 */

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';
import type { PocketQrRestoreEntry } from '@/types/pocketSettings';

interface Props {
  entries: PocketQrRestoreEntry[];
}

function formatDate(iso: string): string {
  try {
    return new Date(iso).toLocaleString();
  } catch {
    return iso;
  }
}

export function RecentRestoresList({ entries }: Props) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base font-semibold">
          Recent restores (last 7 days)
        </CardTitle>
      </CardHeader>
      <CardContent>
        {entries.length === 0 ? (
          <p className="text-sm text-muted-foreground">No restore activity in the last 7 days.</p>
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>When</TableHead>
                <TableHead>Actor</TableHead>
                <TableHead>QR</TableHead>
                <TableHead>State</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {entries.map((entry, idx) => (
                <TableRow key={`${entry.qr_id}-${idx}`}>
                  <TableCell className="whitespace-nowrap tabular-nums">
                    {formatDate(entry.occurred_at)}
                  </TableCell>
                  <TableCell>{entry.actor_name || '—'}</TableCell>
                  <TableCell className="font-mono text-xs">
                    {entry.qr_id.slice(0, 8)}…
                  </TableCell>
                  <TableCell>
                    {entry.was_archived ? (
                      <Badge variant="outline">Restored archived</Badge>
                    ) : (
                      <Badge variant="secondary">Restored retired</Badge>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
}
